/** False on the server and on local hosts, where analytics stay off. */
export function isAnalyticsHost(): boolean {
  if (typeof window === "undefined") return false;
  const hostname = window.location.hostname;
  return (
    hostname !== "localhost" &&
    hostname !== "127.0.0.1" &&
    hostname !== "0.0.0.0"
  );
}
